<template>
  <div class="scanEffectiveContent">
    <div class="orderContent">
      <a-radio-group
        v-model:value="submitParams.confirmed"
        style="margin-bottom: 20px"
        name="radioGroup"
        @change="changeMainType"
      >
        <!-- NOTE:不需要展示这一项
          <a-radio :value="1">患者已复诊</a-radio>
        -->
        <a-radio :value="2">修改复诊信息</a-radio>
      </a-radio-group>
      <a-form
        layout="vertical"
        v-if="submitParams.confirmed === 1"
        :model="submitParams"
        ref="scanFormRef"
        class="retreatForm"
      >
        <a-form-item label="核销复诊依据" name="completeCureActionId" style="margin-bottom: 40px">
          <a-select
            v-model:value="submitParams.completeCureActionId"
            style="width: 100%"
            placeholder="请选择"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            :options="recordCusMap.completeReserveActionRecordList"
          ></a-select>
        </a-form-item>
        <a-form-item
          v-if="
            recordCusMap.effectiveScanQueryResponseList &&
            recordCusMap.effectiveScanQueryResponseList.length
          "
          :rules="{
            required: recordCusMap.effectiveScanQueryResponseList.length,
            message: '请选择'
          }"
          label="添加扫码记录"
          name="scanId"
        >
          <a-select
            v-model:value="submitParams.scanId"
            style="width: 100%"
            placeholder="请选择"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            :options="recordCusMap.effectiveScanQueryResponseList"
          ></a-select>
        </a-form-item>
      </a-form>
    </div>
    <div class="orderContent">
      <RetreatForm ref="reFormRef" v-if="submitParams.confirmed === 2" />
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, defineProps, defineExpose, defineEmits, nextTick, onMounted } from 'vue'
import RetreatForm from './retreatForm.vue'
import useScanHooks from './useScanHooks'

const submitParams = reactive({
  confirmed: null,
  scanId: null,
  completeCureActionId: null
})

const prop = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {}
  }
})

const { recordCusMap, getRecordDayly } = useScanHooks(prop)

onMounted(() => {
  getRecordDayly()
})

const scanFormRef = ref()
const reFormRef = ref()
const submitForm = () => {
  return reFormRef.value?.submitValidQuery()
}

const emit = defineEmits(['confirmReserce'])
const changeMainType = e => {
  if (e.target.value === 1) {
    autoSelect()
  }
  emit('confirmReserce', e.target.value)
  nextTick(() => {
    reFormRef.value?.resetFields()
  })
}

const autoSelect = () => {
  const { completeReserveActionRecordList, effectiveScanQueryResponseList } = recordCusMap || {}
  submitParams.completeCureActionId = completeReserveActionRecordList.length
    ? completeReserveActionRecordList[0].completeCureActionId
    : null
  submitParams.scanId = effectiveScanQueryResponseList.length
    ? effectiveScanQueryResponseList[0].scanId + ''
    : null
}

const mainformValid = () => {
  if (!scanFormRef.value) {
    const confirmed = reFormRef.value ? 2 : null
    return { confirmed }
  } else {
    return new Promise((resolve, reject) => {
      scanFormRef.value
        .validate()
        .then(() => {
          const { completeCureActionId, scanId } = submitParams
          const temp1 = recordCusMap.completeReserveActionRecordList.filter(item => {
            return item.completeCureActionId === completeCureActionId
          })
          const { completeCureActionType, scanCureActionId, scanCureActionType } = temp1[0]
          resolve({
            ...submitParams,
            completeCureActionId,
            completeCureActionType,
            scanCureActionId,
            scanCureActionType,
            scanId
          })
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
defineExpose({
  mainformValid,
  submitForm
})
</script>
<style lang="scss" scoped>
@import './normalizeOrder.scss';
</style>
